export default "__VITE_ASSET__C21nyacX__"